var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncreaseEngagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 229.432,
    height: 233.372,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 0.019,
    x2: 0.5,
    y2: 1.019,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b72b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fc4fd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-615 -115)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209.125,
    height: 209.125,
    rx: 40,
    transform: "translate(615 139.246)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.58,
    cy: 30.58,
    r: 30.58,
    transform: "translate(783.271 115)",
    fill: "#e32f2f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseEngagement);
export default __webpack_public_path__ + "static/media/increaseEngagement.f9641b35fdab4e16758a2454c42e5f1e.svg";
export { ForwardRef as ReactComponent };